import { useLogout } from "$src/lib/auth";
import { cx } from "$src/lib/utils";
import {
  HelpCircle,
  KeyRound,
  LogOut,
  Milestone,
  Settings,
} from "lucide-react";
import { type ComponentProps, useState } from "react";
import { useBrandContextPanel } from "$src/stores/use-brand-context-panel";
import { ControlledDropdown, DropdownSection } from "../dropdown/dropdown";
import { SettingsMenuItem } from "./lib/settings-menu-item";

import styles from "./settings-dropdown.module.css";

export const SettingsDropdown = ({
  className,
  ...props
}: ComponentProps<"div">) => {
  const [open, setOpen] = useState(false);
  const { open: openBrandContextPanel, openMilestones } =
    useBrandContextPanel();
  const logout = useLogout();

  const handleBrandContext = () => {
    openBrandContextPanel();
    setOpen(false);
  };

  const handleMilestones = () => {
    openMilestones();
    setOpen(false);
  };

  return (
    <ControlledDropdown
      open={open}
      onChange={setOpen}
      chevronVisible={false}
      align="left"
      label={
        <span className={cx(styles.button, open && styles.active)}>
          <Settings size={24} strokeWidth={1.5} />
        </span>
      }
      className={cx(styles.dropdown, className)}
      {...props}
    >
      <SettingsMenuItem
        icon={Milestone}
        label="Milestones"
        onClick={handleMilestones}
      />
      <SettingsMenuItem
        icon={Milestone}
        label="Context and milestones"
        onClick={handleBrandContext}
      />
      <SettingsMenuItem
        icon={Settings}
        label="Account settings"
        href="/embedding-brand/settings"
        onClick={() => setOpen(false)}
      />
      <SettingsMenuItem
        icon={KeyRound}
        label="Setup & security"
        onClick={() => setOpen(false)}
      />
      <DropdownSection>
        <SettingsMenuItem
          icon={HelpCircle}
          label="Help center"
          href="https://help.gotracksuit.com/"
          onClick={() => setOpen(false)}
        />
      </DropdownSection>
      <DropdownSection>
        <SettingsMenuItem icon={LogOut} label="Logout" onClick={logout} />
      </DropdownSection>
    </ControlledDropdown>
  );
};
